module.exports = __webpack_public_path__ + "static/img/年度最佳MPV.e1ad2174.png";